import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField,
} from '@material-ui/core';
import {
  NotificationScheduleProps,
} from './types';

const NotificationSchedule: React.FC <NotificationScheduleProps> = (
  props: NotificationScheduleProps,
) => {
  const {
    handleChange,
    error,
  } = props;
  const [sendTime, setStartDate] = useState<string>('');

  useEffect(() => {
    handleChange(sendTime);
  }, [sendTime, handleChange]);

  return (
    <TextField
      fullWidth
      type="datetime-local"
      value={sendTime}
      onChange={(e) => setStartDate(e.target.value)}
      required
      error={error}
    />
  );
};

export default NotificationSchedule;
